import React from 'react'
import { Typography } from 'antd'
import { cleanForm } from '../../app/cacheUtil'

const { Title, Text } = Typography

export const initMultipleSelect = (str) => {
  if (str) {
    if (str === '') return []
    return str.split(',')
  } else {
    return []
  }
}

export const RequiredTitle = (text) => {
  return (
    <Text>
      {text} <span style={{ fontSize: 14, color: 'gray' }}>(Required)</span>
    </Text>
  )
}

export const newPiecesStepCount = 'newPiecesStepCount'
export const newPiecesBasic = 'newPiecesBasic'
export const newPiecesDetail = 'newPiecesDetail'
export const newPiecesBusinessType = 'newPiecesBusinessType'
export const newPiecesPrice = 'newPiecesPrice'

export const cleanAllCachedNewPieces = () => {
  cleanForm(newPiecesStepCount)
  cleanForm(newPiecesBasic)
  cleanForm(newPiecesDetail)
  cleanForm(newPiecesBusinessType)
  cleanForm(newPiecesPrice)
}
